module.exports = __webpack_public_path__ + "img/Michael_Snyder.a0480a9a.jpg";